import React from 'react';
import FilterContainer from '@src/components/overview-dashboard/filter';
import DatePicker from '@components/overview-dashboard/overview-date-picker';
import KebabDropDown from '@components/overview-dashboard/kebab-dropdown';
import { SummaryWrapper, RightTopBarWrapper } from '../styled';
// eslint-disable-next-line react/display-name
export default ({ currentShareId, pageType }) => (
  <SummaryWrapper>
    <FilterContainer />
    <RightTopBarWrapper>
      <DatePicker />
      <KebabDropDown currentShareId={currentShareId} pageType={pageType} />
    </RightTopBarWrapper>
  </SummaryWrapper>
);
